/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crash_BodyInputs */

const th_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาดในแอป ไม่ใช่ที่การเชื่อมต่อของคุณ การโหลดหน้าใหม่มักจะแก้ปัญหาได้ และเราได้รับแจ้งปัญหานี้แล้ว`)
};

const en_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something in the app broke, not your connection. Reloading usually fixes it, and we have been told what happened.`)
};

const ja_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続ではなく、アプリ内で問題が発生しました。ページを再読み込みすると解決することがほとんどです。問題は報告されました。`)
};

const zh_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是应用出了问题，不是你的网络。重新加载通常能解决，我们也已经收到了通知。`)
};

const es_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo se ha roto en la aplicación, no en tu conexión. Recargar suele solucionarlo, y ya nos han avisado de lo ocurrido.`)
};

const pt_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo quebrou no aplicativo, não na sua conexão. Recarregar costuma resolver, e já fomos avisados do que aconteceu.`)
};

const id_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang rusak di aplikasi, bukan koneksi Anda. Memuat ulang biasanya membantu, dan kami sudah diberi tahu.`)
};

const fr_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelque chose a cassé dans l’application, pas votre connexion. Recharger suffit en général, et nous avons été prévenus.`)
};

const tl_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May nasira sa app, hindi ang koneksyon mo. Kadalasan ay nakakatulong ang pag-reload, at naipaalam na ito sa amin.`)
};

const vi_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có gì đó hỏng trong ứng dụng, không phải kết nối của bạn. Tải lại thường có ích, và chúng tôi đã được báo.`)
};

const ko_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결이 아니라 앱에서 문제가 생겼습니다. 대개 새로 고치면 해결되며, 저희에게도 이미 전달되었습니다.`)
};

const de_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der App ist etwas kaputtgegangen, nicht deine Verbindung. Neu laden hilft meistens, und wir wurden bereits informiert.`)
};

const ru_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то сломалось в приложении, а не в вашем соединении. Обычно помогает перезагрузка, и нам уже сообщили.`)
};

const tr_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantınız değil, uygulama bozuldu. Yeniden yüklemek genelde işe yarar ve durumdan haberimiz oldu.`)
};

const it_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è rotto qualcosa nell'app, non la tua connessione. Ricaricare di solito basta, e siamo già stati avvisati.`)
};

const pl_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zepsuło się coś w aplikacji, a nie twoje połączenie. Odświeżenie zwykle pomaga, a my już dostaliśmy zgłoszenie.`)
};

const uk_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щось зламалося в застосунку, а не ваше з'єднання. Перезавантаження зазвичай допомагає, і нам уже повідомили.`)
};

const hi_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐप में कुछ टूट गया, आपका कनेक्शन नहीं। पुनः लोड करने से आमतौर पर काम बन जाता है, और हमें सूचना मिल चुकी है।`)
};

const ar_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث عطل في التطبيق، لا في اتصالك. إعادة التحميل تنفع عادةً، وقد وصلنا الإبلاغ.`)
};

const ms_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang rosak dalam aplikasi, bukan sambungan anda. Memuat semula biasanya membantu, dan kami sudah dimaklumkan.`)
};

const bn_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপে কিছু ভেঙেছে, আপনার সংযোগে নয়। পুনরায় লোড করলে সাধারণত কাজ হয়, আর আমাদের জানানো হয়ে গেছে।`)
};

const zh_tw2_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是應用程式出了問題，不是你的網路。重新載入通常就能解決，我們也已經收到通知。`)
};

const zh_hk2_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是應用程式出了問題，不是你的網絡。重新載入通常就能解決，我們也已經收到通知。`)
};

const ur_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایپ میں کچھ خراب ہوا ہے، آپ کا کنکشن نہیں۔ دوبارہ لوڈ کرنے سے عموماً کام بن جاتا ہے، اور ہمیں اطلاع مل چکی ہے۔`)
};

const fa_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چیزی در برنامه خراب شده، نه اتصال شما. معمولاً بارگذاری دوباره کارساز است، و ما هم خبردار شده‌ایم.`)
};

const sw_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuna kitu kimeharibika ndani ya programu, si muunganisho wako. Kupakia upya husaidia mara nyingi, na tayari tumearifiwa.`)
};

const nl_crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is iets stukgegaan in de app, niet in je verbinding. Herladen helpt meestal, en wij zijn al op de hoogte.`)
};

/**
* | output |
* | --- |
* | "Something in the app broke, not your connection. Reloading usually fixes it, and we have been told what happened." |
*
* @param {Crash_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const crash_body = /** @type {((inputs?: Crash_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crash_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_crash_body(inputs)
	if (locale === "ja") return ja_crash_body(inputs)
	if (locale === "zh") return zh_crash_body(inputs)
	if (locale === "es") return es_crash_body(inputs)
	if (locale === "pt") return pt_crash_body(inputs)
	if (locale === "id") return id_crash_body(inputs)
	if (locale === "fr") return fr_crash_body(inputs)
	if (locale === "tl") return tl_crash_body(inputs)
	if (locale === "vi") return vi_crash_body(inputs)
	if (locale === "ko") return ko_crash_body(inputs)
	if (locale === "de") return de_crash_body(inputs)
	if (locale === "ru") return ru_crash_body(inputs)
	if (locale === "tr") return tr_crash_body(inputs)
	if (locale === "it") return it_crash_body(inputs)
	if (locale === "pl") return pl_crash_body(inputs)
	if (locale === "uk") return uk_crash_body(inputs)
	if (locale === "hi") return hi_crash_body(inputs)
	if (locale === "ar") return ar_crash_body(inputs)
	if (locale === "ms") return ms_crash_body(inputs)
	if (locale === "bn") return bn_crash_body(inputs)
	if (locale === "zh-TW") return zh_tw2_crash_body(inputs)
	if (locale === "zh-HK") return zh_hk2_crash_body(inputs)
	if (locale === "ur") return ur_crash_body(inputs)
	if (locale === "fa") return fa_crash_body(inputs)
	if (locale === "sw") return sw_crash_body(inputs)
	if (locale === "nl") return nl_crash_body(inputs)
	return en_crash_body(inputs)
});